import { FC, ReactNode } from "react";
import { Ripple } from "./Ripple";
import { useRipple } from "./useRipple";

interface RippleWrapperProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

export const RippleWrapper: FC<RippleWrapperProps> = ({ children, className = "", onClick }) => {
  const { ripples, create, remove } = useRipple();

  return (
    <div
      className={`ripple-wrapper ${className}`}
      style={{ position: "relative", overflow: "hidden", display: "inline-block" }}
      onClick={(e) => {
        create(e);
        onClick?.();
      }}
    >
      {children}
      {ripples.map((r) => (
        <Ripple key={r.id} x={r.x} y={r.y} size={r.size} onComplete={() => remove(r.id)} />
      ))}
    </div>
  );
};
